// extracted by mini-css-extract-plugin
module.exports = {"sidebarNav":"DocumentationSidebar_sidebarNav__3N5_x","collapsibleTrigger":"DocumentationSidebar_collapsibleTrigger__iE_u4"};